var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9785 24.7283C28.9785 27.1054 27.0497 29.036 24.6725 29.036H14.9477C12.5706 29.036 10.64 27.1054 10.64 24.7283V15.0034C10.64 12.6245 12.5706 10.6975 14.9477 10.6975H24.6725C27.0497 10.6975 28.9785 12.6245 28.9785 15.0034V24.7283ZM24.5618 8.57178H15.0585C11.4752 8.57178 8.57231 11.4746 8.57231 15.0579V24.5595C8.57231 28.1463 11.4752 31.0456 15.0585 31.0456H24.5618C28.1451 31.0456 31.0479 28.1463 31.0479 24.5595V15.0579C31.0479 11.4746 28.1451 8.57178 24.5618 8.57178Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8094 23.6455C17.7224 23.6455 16.0292 21.9541 16.0292 19.867C16.0292 17.7783 17.7224 16.0833 19.8094 16.0833C21.8982 16.0833 23.5896 17.7783 23.5896 19.867C23.5896 21.9541 21.8982 23.6455 19.8094 23.6455ZM19.8094 14.0332C16.5866 14.0332 13.9791 16.646 13.9791 19.867C13.9791 23.0846 16.5866 25.6974 19.8094 25.6974C23.0305 25.6974 25.6433 23.0846 25.6433 19.867C25.6433 16.646 23.0305 14.0332 19.8094 14.0332Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8372 12.4521C25.0882 12.4521 24.4781 13.0605 24.4781 13.8113C24.4781 14.562 25.0882 15.1704 25.8372 15.1704C26.588 15.1704 27.1963 14.562 27.1963 13.8113C27.1963 13.0605 26.588 12.4521 25.8372 12.4521Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.4004ad4000a595246d914c55e61fb816.svg";
export { ForwardRef as ReactComponent };